import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/beta/cdf';
import __var_2__ from '@stdlib/stats/base/dists/beta/ctor';
import __var_3__ from '@stdlib/stats/base/dists/beta/entropy';
import __var_4__ from '@stdlib/stats/base/dists/beta/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/beta/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/beta/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/beta/mean';
import __var_8__ from '@stdlib/stats/base/dists/beta/median';
import __var_9__ from '@stdlib/stats/base/dists/beta/mgf';
import __var_10__ from '@stdlib/stats/base/dists/beta/mode';
import __var_11__ from '@stdlib/stats/base/dists/beta/pdf';
import __var_12__ from '@stdlib/stats/base/dists/beta/quantile';
import __var_13__ from '@stdlib/stats/base/dists/beta/skewness';
import __var_14__ from '@stdlib/stats/base/dists/beta/stdev';
import __var_15__ from '@stdlib/stats/base/dists/beta/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace beta
*/
var beta = {};

/**
* @name cdf
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/cdf}
*/
setReadOnly( beta, 'cdf', __var_1__);

/**
* @name Beta
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/ctor}
*/
setReadOnly( beta, 'Beta', __var_2__);

/**
* @name entropy
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/entropy}
*/
setReadOnly( beta, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/kurtosis}
*/
setReadOnly( beta, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/logcdf}
*/
setReadOnly( beta, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/logpdf}
*/
setReadOnly( beta, 'logpdf', __var_6__);

/**
* @name mean
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/mean}
*/
setReadOnly( beta, 'mean', __var_7__);

/**
* @name median
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/median}
*/
setReadOnly( beta, 'median', __var_8__);

/**
* @name mgf
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/mgf}
*/
setReadOnly( beta, 'mgf', __var_9__);

/**
* @name mode
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/mode}
*/
setReadOnly( beta, 'mode', __var_10__);

/**
* @name pdf
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/pdf}
*/
setReadOnly( beta, 'pdf', __var_11__);

/**
* @name quantile
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/quantile}
*/
setReadOnly( beta, 'quantile', __var_12__);

/**
* @name skewness
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/skewness}
*/
setReadOnly( beta, 'skewness', __var_13__);

/**
* @name stdev
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/stdev}
*/
setReadOnly( beta, 'stdev', __var_14__);

/**
* @name variance
* @memberof beta
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/beta/variance}
*/
setReadOnly( beta, 'variance', __var_15__);


// EXPORTS //
export default beta;

export { __var_1__ as cdf, __var_2__ as Beta, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as stdev, __var_15__ as variance};